export default [
  {
    text: '#',
    value: 'id',
    width: '5%',
  },
  {
    text: 'nombre',
    value: 'name',
  },
  {
    text: 'precio venta',
    value: 'salePriceItem',
    align: 'right',
    format: 'currency',
    width: '10%',
  },
]
